import { combineReducers, compose, createStore as _createStore, StoreEnhancer } from 'redux';
import { noopReducer, promoDetailsReducer } from '../../reducers';
import { IExperiment } from '../../types/experiments';
import { IPromosPage } from '../../types/promosPage';
import {
  IAnalytics,
  IApplicationState,
  TReduxActions,
  TReduxStore,
  IPage,
  IApplicationInitialState,
} from '../../types/redux';
import { ISeoData } from '../../types/seoData';
import { TUser } from '../../types/user';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: IApplicationInitialState, debugEnabled: boolean) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    analytics: noopReducer<IAnalytics>(),
    experiments: noopReducer<IExperiment[]>(),
    page: noopReducer<IPage>(),
    promosPage: noopReducer<IPromosPage>(),
    promoDetails: promoDetailsReducer,
    seoData: noopReducer<ISeoData>(),
    user: noopReducer<TUser>(),
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers() as StoreEnhancer<IApplicationState>;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationInitialState, TReduxActions, {}, IApplicationState>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
